import styled from "styled-components";
import { staticText } from "../../statics/static-text";

// TEXT
export const text = staticText.components.secretText;

// STYLES
export const Secret = styled.span<{ $hidden: boolean }>`
  ${({ $hidden }) => $hidden && "font-family: monospace;"}
`;

// DATA

// TYPES
export type Props = {
  fetcher?: () => Promise<string>;
  disabled?: boolean;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
